import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {RootState} from '../interfaces'
import aitems from '../slices/aitems'
import banner from '../slices/banner'
import common from '../slices/common'
import deliveryTracking from '../slices/deliveryTracking'
import purchaser from '../slices/purchaser'
import recommendationProduct from '../slices/recommendationProduct'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        aitems,
        banner,
        common,
        deliveryTracking,
        recommendationProduct,
        router: routerReducer,
        purchaser,
    })

export default createRootReducer
